<template>
  <CRow>
    <CCol v-for="(option, index) of info.extension_info.values" :key="option">
      <CFormCheck
        type="radio"
        :id="`${info.part_item_id}${index}`"
        :label="option"
        :value="option"
        :checked="index === optionId"
        @change="emitContent(index)"
        required
        :name="info.part_item_id"
        :model-value="index === 0"
      />
    </CCol>
    <CCol>
      <div v-if="info.extension_info.last === '其他'">
        <CFormCheck
          type="radio"
          :id="`${info.part_item_id}${info.extension_info.values.length}`"
          :value="-1"
          :checked="optionId === -1"
          @change="emitContent(-1)"
          label="其他"
          required
          :name="info.part_item_id"
          :model-value="index === 0"
        />
        <CFormInput :disabled="(optionId !== -1)" class="col-12 mt-2" placeholder="請填寫其他內容" />
      </div>
    </CCol>
  </CRow>
</template>
<script>
import { ref } from '@vue/runtime-core'
export default {
  props: {
    id: {
      type: [Number, String],
      default: undefined,
    },
    type: {
      type: String,
      default: '',
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const optionId = ref(null)
    const emitContent = (id) => {
      if (optionId.value === id) optionId.value = null
      optionId.value = id
    }
    return {
      optionId,
      emitContent,
    }
  },
}
</script>
